export default __webpack_public_path__ + "assets/images/CVV-mobile-front_3007ef44c8de7cf7ebf6f2112c31b406.png";